import useNavigation from '@src/Navigation/useNavigation';

const useSignInSuccess = () => {
  const rootNavigation = useNavigation();
  const onSuccess = () => {
    if (
      typeof window !== 'undefined' &&
      !window.location.pathname.includes('/tv-auth') &&
      !window.location.pathname.includes('/subscription')
    ) {
      rootNavigation.navigate('/app', {
        replace: true,
      });
    }
  };

  return {onSuccess};
};

export default useSignInSuccess;
